import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { formulateAppMessageResult, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for pages.tabs module related message requests.
 */
var AppEntityMessageHandler = /** @class */ (function (_super) {
    __extends(AppEntityMessageHandler, _super);
    function AppEntityMessageHandler(appSdkHost, appEntityService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.appEntityService = appEntityService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    AppEntityMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.appEntity.selectAppEntity, function (_, threadId, categories, subEntityId) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.appEntityService.selectAppEntity(threadId, categories, subEntityId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, formulateAppMessageResult([null, response])];
                }
            });
        }); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.appEntity.selectAppEntity, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
    };
    AppEntityMessageHandler.prototype.validateDependencies = function () {
        if (!this.appEntityService) {
            throw 'No appEntityService provided';
        }
    };
    return AppEntityMessageHandler;
}(BaseMessageHandler));
export { AppEntityMessageHandler };
//# sourceMappingURL=appentity-message-handler.js.map